import { MAX_TITLE_LENGTH, MAX_TYPES_IN_BUTTON, TITLE_SLICE, TITLE_SLICE_MOBILE } from './config';

export function formatFilterTitle(title: string, count: number, isMobile?: boolean): string {
  const needsTruncation = title.length > MAX_TITLE_LENGTH;
  const isCounterVisible = count > MAX_TYPES_IN_BUTTON;

  let result = title;

  const slice = isMobile ? TITLE_SLICE_MOBILE : TITLE_SLICE;

  if (needsTruncation) {
    result = `${title.slice(0, slice)}...`;
  }

  if (isCounterVisible) {
    result += ` (${count})`;
  }

  return result;
}
